
import BaseButton from '@/components/Common/BaseButton/BaseButton.vue';
import BaseTitle from '@/components/Common/BaseTitle/BaseTitle.vue';
import useConfirmEmailForm from './ConfirmEmailForm';

export default {
  components: {
    BaseButton,
    BaseTitle,
  },
  setup() {
    return useConfirmEmailForm();
  },
};
